import { Input } from 'antd';

import { Form, StyledModal } from 'common/components';

import { QaSpecHelpContentLabel } from 'pages/qa-spec/components/shared/QaSpecHelpContent';

import TraceableCommentContainer from 'pages/traceable-comment/TraceableCommentContainer';

import { TOOlTIP_FIELDS } from 'static/tooltipFields';
import { getFormattedPath } from '../shared/QaSpecHelper';

const ModalUpdateDocument = ({ formInstance, ...otherProps }) => {
  return (
    <StyledModal title='Update Document' {...otherProps}>
      <Form
        form={formInstance}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
      >
        <Form.Item
          label={
            <TraceableCommentContainer
              qaSpecName='Manufacturing Process'
              qaSpecFieldName='Document Name'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.documentName.fieldPath}
              >
                Document Name
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
          name='documentName'
        >
          <Input />
        </Form.Item>
      </Form>
    </StyledModal>
  );
};

export default ModalUpdateDocument;
